import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import Translatable from '@/app-core/mixins/translatable'
import ProductPrice from '@/app-theme/components/product/ProductPrice.vue'
import ProductCommon from '@/app-core/mixins/product/productCommon'
import ProductListCommon from '@/app-core/mixins/product/productListCommon'
import ProductDialogQuantitySelector from '@/app-theme/components/product/ProductDialogQuantitySelector.vue'
import {clone} from '@/app-core/lib/utils/helper'
import ProductTags from '@/app-theme/components/product/ProductTags.vue'
import {hasClass, toggleClass} from '@/core/lib/utils/browser/index.js'

export default {
  name      : 'ProductDetailsDialog',
  components: {
    ProductTags,
    ProductDialogQuantitySelector,
    ProductPrice
  },
  mixins: [DialogVisible, Translatable, ProductCommon, ProductListCommon],
  props : {
    product: {
      type   : Object,
      default: undefined
    },
    editMode: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {
      toolbarVisible: false
    }
  },
  computed: {
    toolbarHeight() {
      if (this.$vuetify.breakpoint.smAndUp) return 125
      return 84
    }
  },
  watch: {
    isVisible(newVal) {
      if (!newVal && this.$refs.cardText) this.$refs.cardText.scrollTop = 0

      if (newVal) {
        this.selectedProduct = clone(this.product)
        this.initProduct()

        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  },
  methods: {
    visibilityChanged(entries, observer, isIntersecting) {
      this.toolbarVisible = !isIntersecting
    },

    toggleProductDescription() {
      const element = document.querySelector('div.product-details-description')
      toggleClass(element, 'text-overflow-3')
      this.$forceUpdate()
    },

    productDescriptionHasOverflow() {
      const element = document.querySelector('div.product-details-description')
      if (!element) return false

      const tolerance = 0 // In px. Depends on the font you are using
      const ellipsisActive = element?.offsetWidth + tolerance < element?.scrollWidth
      return ellipsisActive && hasClass(element, 'text-overflow-3')
    },

    onSaveButtonClick() {
      if (!this.isRequiredOptionsValid()) return

      this.$bus.$emit('cart:add-product', this.selectedProduct)
      this.onCancelButtonClick()
    },

    onCancelButtonClick() {
      this.isVisible = false
      this.toolbarVisible = false
      this.selectedProduct = null
    }
  }
}
